import { ClientPolicyDto } from '@core/pages/new-business-register/api'
import { FrequencyToValueMappingCalculation, FrequencyType } from '@master/model/options/FrequencyOptions'
import { ProductRider } from './model/ProductRider'

export function calculateAsp (frequency: FrequencyType, modalPremium: number) {
  let result = 0
  result = modalPremium * FrequencyToValueMappingCalculation(frequency)
  return result
}

export function calculateModalPremium (riders: ProductRider[], basicModalPremium: number) {
  const totalRiderPremium = (riders || []).map(e => {
    return (+e.premium || 0) + (+e.ncp || 0)
  }).reduce((a, b) => a + b, 0)
  return basicModalPremium + totalRiderPremium
}

export function calculateModalPremiumV2 (riders: ClientPolicyDto[], basicModalPremium: number) {
  const totalRiderPremium = (riders || []).map(e => {
    return (+e.productMetadata.premiumAmount || 0) + (+e.productMetadata.ncp || 0)
  }).reduce((a, b) => a + b, 0)
  return basicModalPremium + totalRiderPremium
}

export function calculatePremiumPayable (_grossPremium, _discount) {
  const grossPremium = parseFloat(_grossPremium) || 0
  const discount = parseFloat(_discount) || 0
  const result = grossPremium * (1 - (discount / 100))
  return result
}

export function calculateNetPremium (_premiumPayable, _gst) {
  const premiumPayable = parseFloat(_premiumPayable) || 0
  const gst = parseFloat(_gst) || 0
  const gstAmt = (premiumPayable / (100 + gst)) * gst
  const result = premiumPayable - gstAmt
  return result
}

export function calculateAPE (basicModalPremium = 0, premiumTerm = 0, frequency: FrequencyType) {
  const premiumTermValue = premiumTerm < 10 ? premiumTerm / 10 : 1
  const result = basicModalPremium * FrequencyToValueMappingCalculation(frequency) * premiumTermValue
  return result
}
